import React from 'react'
import Aggregator from '../components/Payment/Aggregator'

function AggregatorPage() {
  return (
    <>
    <Aggregator/>
    </>
  )
}

export default AggregatorPage
